import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";
import axios from "axios";
import { Provider } from "react-redux";

import store from "redux/store";

import { API_URL } from "constants/server/api";

axios.defaults.baseURL = API_URL;
axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem("token")}`;

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <App />
      </MaterialUIControllerProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
